import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { WorkflowGraphComponent } from './workflow-graph.component';
import {
  WorkflowGraphVertexComponent,
  WorkflowGraphVertexInletPointComponent,
  WorkflowGraphVertexOutletPointComponent
} from './vertex';
import { WorkflowGraphDrawEdgeComponent, WorkflowGraphEdgeComponent } from './edge';

const EXTERNAL_COMPONENTS = [
  WorkflowGraphComponent
];

const INTERNAL_COMPONENTS = [
  WorkflowGraphVertexComponent,
  WorkflowGraphVertexInletPointComponent,
  WorkflowGraphVertexOutletPointComponent,
  WorkflowGraphDrawEdgeComponent,
  WorkflowGraphEdgeComponent
];

@NgModule({
  imports: [
    CommonModule,
  ],
  exports: EXTERNAL_COMPONENTS,
  declarations: [ ...EXTERNAL_COMPONENTS, ...INTERNAL_COMPONENTS ],
  entryComponents: [ WorkflowGraphComponent ]
})
export class WorkflowGraphModule {

}



// WEBPACK FOOTER //
// ./src/library/graph/workflow-graph.module.ts